<ng-container *ngIf="trans_key">
    <app-dcintrac-send-successful [amount]="billerService.successAmount"></app-dcintrac-send-successful>
</ng-container>
<ng-container *ngIf="!trans_key && payment_source_success">
    <app-payment-source-biller-success></app-payment-source-biller-success>
</ng-container>
